import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Grid, Group } from '@mantine/core'
import { Alert, Button } from '@/components/Elements'
import { PasswordInputController } from '@/components/FormElements'
import { PASSWORD_MIN_LENGTH } from '@/const/form'
import { useFormSubmit } from '@/hooks'
import { validationSchema } from './validation'

interface IProps {
  onSubmit: (values: object) => Promise<void>
}

export const PasswordForm = ({ ...props }: IProps) => {
  const { t } = useTranslation()

  const methods = useForm({
    defaultValues: {
      current_password: '',
      password: '',
      password_confirmation: '',
    },
    resolver: yupResolver(validationSchema),
  })

  const {
    control,
    handleSubmit,
    setError,
    reset,
    formState: { isSubmitting },
  } = methods

  const { error: submitError, onSubmit: onFormSubmit } = useFormSubmit({
    submit: props.onSubmit,
    setError,
  })

  const onSubmit: SubmitHandler<any> = async (data) => {
    try {
      await onFormSubmit(data)
      reset()
    } catch (error) {}
  }

  return (
    <>
      <FormProvider {...methods}>
        {submitError && (
          <Alert type={'error'} mb={'sm'}>
            {submitError?.data?.message || t('error')}
          </Alert>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid>
            <Grid.Col md={4}>
              <PasswordInputController
                control={control}
                name={'current_password'}
                id={'current_password'}
                label={t('current_password')}
                placeholder={t('current_password')}
                mb={'md'}
                translateParams={{ count: PASSWORD_MIN_LENGTH }}
              />
            </Grid.Col>

            <Grid.Col md={4}>
              <PasswordInputController
                control={control}
                name={'password'}
                id={'password'}
                label={t('new_password')}
                placeholder={t('new_password')}
                mb={'md'}
                translateParams={{ count: PASSWORD_MIN_LENGTH }}
              />
            </Grid.Col>

            <Grid.Col md={4}>
              <PasswordInputController
                control={control}
                name={'password_confirmation'}
                id={'password_confirmation'}
                label={t('confirm_new_password')}
                placeholder={t('confirm_new_password')}
                mb={'md'}
                translateParams={{ count: PASSWORD_MIN_LENGTH }}
              />
            </Grid.Col>
          </Grid>

          <div className={'flex'}>
            <Group>
              <Button loading={isSubmitting} type={'submit'}>
                {t('save')}
              </Button>
            </Group>
          </div>
        </form>
      </FormProvider>
    </>
  )
}
